export default class Report {
  constructor() {
    this.locations = [];
  }
}
